import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { AiReveniIcon, Text } from '@reveni-io/reveni-ui'

import CodeText from '../CodeText/CodeText'
import * as Styles from './styles'

const PendingContent = ({ proposedCode, proposedDescription }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Styles.RightColumn>
      <Styles.HeaderRecommendation>
        <AiReveniIcon size={14} />
        <Text type="allCapsM" color={theme.colors.text.muted}>
          {t('Recomendación')}
        </Text>
      </Styles.HeaderRecommendation>
      <Styles.DescriptionTextContainer>
        <CodeText code={proposedCode} variant="proposed" />
        {proposedDescription && (
          <Text type="bodyMRegular" color={theme.colors.text.default}>
            {proposedDescription}
          </Text>
        )}
      </Styles.DescriptionTextContainer>
    </Styles.RightColumn>
  )
}

export default PendingContent
